import type { ApiResponse } from '../../shared/contracts/api'

export class ApiError extends Error {
  constructor(
    public readonly code: string,
    message: string,
    public readonly status: number,
  ) {
    super(message)
  }
}

export async function apiRequest<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    credentials: 'same-origin',
    headers: { 'content-type': 'application/json', ...init?.headers },
  })
  const contentType = response.headers.get('content-type') ?? ''
  if (!contentType.includes('application/json')) {
    throw new ApiError('INVALID_SERVER_RESPONSE', 'The server encountered an unexpected error. Please try again.', response.status)
  }
  const body = (await response.json()) as ApiResponse<T>
  if (!body.ok) throw new ApiError(body.error.code, body.error.message, response.status)
  return body.data
}

export async function apiUpload<T>(path: string, form: FormData): Promise<T> {
  const response = await fetch(path, { method: 'POST', body: form, credentials: 'same-origin' })
  const body = (await response.json()) as ApiResponse<T>
  if (!body.ok) throw new ApiError(body.error.code, body.error.message, response.status)
  return body.data
}
